import React from "react";
import { ArticleRow } from "./articleRow";

export default class ArticlesTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    let articlesRows = this.props.articles.map((t, i) => {
      return (
        <ArticleRow
          key={t.id}
          index={i}
          article={t}
          articlesSize={this.props.articles.length}
          yearId={this.props.yearId}
          canUserApprove={this.props.canUserApprove}
          createdYear={this.props.createdYear}
          canEditPapers={this.props.canEditPapers}
          canSetArticolBugetar={this.props.canSetArticolBugetar}
          onVatChanged={this.props.onVatChanged}
          onDetailChanged={this.props.onDetailChanged}
          onQuantityChanged={this.props.onQuantityChanged}
          onArticolBugetarChange={this.props.onArticolBugetarChange}
          onPricePerUnitChanged={this.props.onPricePerUnitChanged}
          onDeleteClicked={this.props.onDeleteClicked}
          onEditClicked={this.props.onEditClicked}
          onFileDownloadClick={this.props.onFileDownloadClick}
        />
      );
    });

    return (
      <div>
        {articlesRows &&
          articlesRows.length > 0 && (
            <div style={{ marginTop: "30px" }}>
              <strong>Articole:</strong>
            </div>
          )}
        {articlesRows &&
          articlesRows.length > 0 && (
            <table className="table  table-hover">
              <tbody>
                <tr>
                  <th>Cod articol</th>
                  <th>Denumire articol</th>
                  <th>Detalii articol</th>
                  <th>Pret unitar</th>
                  <th>Cota TVA</th>
                  <th>Cantitate</th>
                  <th>Art. bugetar</th>
                </tr>
                {articlesRows}
              </tbody>
            </table>
          )}
      </div>
    );
  }
}
